import { IParsedMessage } from '../messageUtils';

export const checkNeedUpdateMessages = (
  currentMessages: IParsedMessage[],
  canLoadMore: boolean,
  created: string,
  limit: number,
  offset: number,
): boolean => {
  // с бекенда приходят сообщения в порядке убывания времени создания (самые новые в начале)
  // если запросили обновление по всем сообщениям - то больше не запрашиваем
  // если сообщение которое пришло зарегистировано раньше чем наше - то больше не запрашиваем (нет цели выгрузить весь чат)
  // если сообщение которое пришло зарегистировано позже чем наше и при этом пришел флаг canLoadMore - то запрашиваем еще
  if (currentMessages.length <= offset + limit) {
    return false;
  }

  const createdMs = new Date(created).getTime();

  const firstLoadedMessageTs = new Date(currentMessages[currentMessages.length - 1].message.created).getTime();

  return createdMs > 0 && firstLoadedMessageTs < createdMs && canLoadMore;
};
